import { Link } from 'react-router-dom';
import { navLinks, visitImage, visitInfo } from '@/mocks/home';
import { cdn } from '@/config/cdn';
import PhotoMotion from '@/components/feature/PhotoMotion';

export default function VisitFooter({ showVisit = true }: { showVisit?: boolean }) {
  return (
    <>
      {showVisit && (
      <section className="bg-[#F5F1EB] pt-24 md:pt-40 pb-24 md:pb-32" aria-labelledby="visit-title">
        <div className="fold-shell grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-6 items-center">
          <div className="lg:col-span-6 min-w-0">
            <div className="w-full aspect-[5/6] overflow-hidden bg-[#ebe5dc]">
              <PhotoMotion fromScale={1.05} fromY={22} duration={1.2} parallax={18}>
                <img src={cdn(visitImage.src)} alt={visitImage.alt} title="FOLD. bakery counter" className="w-full h-full object-cover object-center" />
              </PhotoMotion>
            </div>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 min-w-0">
            <p className="fold-label text-[#8A8580]">Visit &amp; Pickup</p>
            <h2 id="visit-title" className="fold-serif mt-6 text-5xl md:text-[72px] leading-[0.95]">
              Come to<br /><span className="italic">the counter.</span>
            </h2>
            <p className="mt-8 text-[15px] leading-relaxed text-[#5d5853] max-w-[400px]">
              One room, one deck oven, one bake a day. Walk in, or request a pickup the day before.
            </p>

            <dl className="mt-10 grid grid-cols-2 gap-x-8 gap-y-5 max-w-[420px]">
              {visitInfo.hours.map((h) => (
                <div key={h.day} className="border-t border-[rgba(23,21,21,0.14)] pt-3">
                  <dt className="fold-label text-[#8A8580]">{h.day}</dt>
                  <dd className="mt-1 text-base tabular-nums">{h.time}</dd>
                </div>
              ))}
            </dl>
            <address className="not-italic mt-8 text-sm leading-relaxed">
              {visitInfo.address}
              <br />
              {visitInfo.phone}
            </address>
            <p className="mt-2 text-xs text-[#8A8580]">Sample details for preview — not verified business information.</p>

            <div className="mt-10 flex flex-wrap items-center gap-8">
              <Link to="/visit#pickup" className="fold-label whitespace-nowrap bg-[#171515] text-[#F5F1EB] px-6 py-4 hover:bg-black transition-colors cursor-pointer">
                Request a pickup
              </Link>
              <Link to="/visit" className="fold-label fold-link whitespace-nowrap cursor-pointer">Directions</Link>
            </div>
          </div>
        </div>
      </section>
      )}

      <footer className="bg-[#EDE7DE] text-[#171515] overflow-hidden">
        <div className="fold-shell pt-14 md:pt-20">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 border-b border-[rgba(23,21,21,0.14)] pb-10">
            <p className="fold-label text-[#5d5853] md:col-span-4">Artisan bakery · Made in layers</p>
            <nav aria-label="Footer" className="md:col-span-5 flex flex-wrap gap-x-10 gap-y-4">
              <Link to="/" className="fold-label whitespace-nowrap hover:opacity-60 cursor-pointer">Home</Link>
              {navLinks.map((l) => (
                <Link key={l.href} to={l.href} className="fold-label whitespace-nowrap hover:opacity-60 cursor-pointer">{l.label}</Link>
              ))}
            </nav>
            <p className="md:col-span-3 md:text-right text-xs text-[#5d5853]">Pickup only · no online payment</p>
          </div>
          <p className="fold-serif leading-[0.8] tracking-[-0.05em] text-[33vw] md:text-[31vw] xl:text-[27rem] mt-8 -ml-[0.04em] -mb-[0.1em] select-none" aria-hidden="true">
            FOLD.
          </p>
        </div>
        <div className="border-t border-[rgba(23,21,21,0.14)]">
          <div className="fold-shell py-5 text-xs text-[#5d5853]">© 2026 FOLD. Bakery</div>
        </div>
      </footer>
    </>
  );
}